<template>
  <div style="background-color: #fff;">
    <center> <img :src="imgUrl" style="width: 100%;margin-bottom: -6px;"></center>
    <h1 style="text-align: center;">{{VideoCard['title']}}</h1>
    <p style="text-align: center;">Time: {{VideoCard['time']}}</p>
    <div style="width: 800px; margin: auto; padding-top: 20px;">
      <div style=" margin-bottom: 10px; position: relative; height: 0; padding-top: 70%;" >
        <iframe
          :src="VideoCard['video_url']"
          allowfullscreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          frameborder="0"
          style="position: absolute; width: 100%; height: 100%; top: 0; left: 0"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
data() {
    return {
      imgUrl: "",
      video_url: "",
      VideoCard: {},
    };
  },
  created() {   
    this.$http.get("api/vue_support/get_videocard?uid="+this.$route.query.uid).then((response) => {
      this.VideoCard = JSON.parse(response.data.data)
    });
    this.$http.get("api/vue_support/get_support_top_img").then((response) => {
      this.imgUrl = response.data.data
    });
  }
}
</script>

<style lang="less" scoped>

</style>
